import createCompiler from 'luq/compile';
import odooCompiler from 'luq/odooCompiler';

const compile = createCompiler(odooCompiler);

export default compile;